import {clickEvent} from "../../webpack/modules/events";

window.addEventListener("resize", () => {
    let descriptions = document.querySelectorAll('.description');
    descriptions.forEach(function(description) {
        let descriptionIsVisible = description.classList.contains('description-opened');
        if (descriptionIsVisible) {
            description.style.maxHeight = '';
            setTimeout(() => {description.style.maxHeight = description.offsetHeight+'px'}, 500);
        }
    });
});

clickEvent('.change-description-visibility', true, function(element) {
    let container = element.closest('.description-container');
    let description = container.querySelector('.description');
    let viewMoreText = element.dataset.viewMoreText;
    let viewLessText = element.dataset.viewLessText;
    let descriptionIsVisible = description.classList.contains('description-opened');

    if (descriptionIsVisible) {
        description.classList.remove('description-opened');
        description.classList.add('description-closed');
        description.style.maxHeight = '';
        element.innerHTML = viewMoreText;
        container.classList.remove('mb-5');
    } else {
        description.classList.remove('description-closed');
        description.classList.add('description-opened');
        element.innerHTML = viewLessText;
        container.classList.add('mb-5');
        setTimeout(() => {description.style.maxHeight = description.offsetHeight+'px'}, 500);
    }
});